import { error, finish } from '../../../../modules/ladders/actions/masterLadder/updatePrice';
import api from '../../../../api';

export function request(dispatch, {price, oldPrice}) {
//     api.patch(`/ladders/masterladder/update-price`, price).then(
//         ladder => dispatch(finish(ladder)),
//         ({errors}) => dispatch(error(errors))
//     );

    $appState.sdkStaff.trading.patchPriceStepInPriceLadder({requestBody: {
        d: price.d,
        f: price.f,
        oldPrice: oldPrice,
    }})
        .then(data => dispatch(finish(data)))
        .catch(errors => dispatch(error(errors)));
}
